var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 856,
    fill: "none",
    viewBox: "0 0 1440 856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 1682,
    height: 1048,
    x: -69,
    y: -192,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M-69 814-6-1.5l-39-88L1497.5-192c73.33 285.667 226.7 727.693-19.5 625-274.5-114.5-622.5-81.5-791 188C465.494 975.278 119.667 826.167-69 814Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1638.41-97H-118v1249h1756.41V-97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C3238",
    d: "M436.365-107.368h-565.953l-48.789 279.928L1259.68 587.267c144.54-93.919 396.17-273.829 246.39-242.116-149.79 31.713-775.547-288.465-1069.705-452.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#554DDE",
    d: "M-149.713 500.695V-50.65C141.953 267.206 1177.03 349.604 1658.11 351.07L1836 1294.71l-944.14-238.27-1041.573-555.745Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E9AF4",
    d: "M9.456 1591.14-168.223 448.256c43.368-146.088 816.795-302.948 1428.083 191.162 611.28 494.112 1040.05 528.882 1480.32 527.192L9.456 1591.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44164F",
    d: "M-200 1274.55V666.743c41.471-72.358 542.168-91.373 877.593 214.551 335.427 305.926 601.127 358.596 877.597 393.256H-200Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EF4E0",
    d: "M1076.59-57.885 526.382-190.467 413.373 70.241 1714.26 810.293c162.52-57.446 449.29-173.402 296.25-177.66-153.04-4.258-686.38-462.119-933.92-690.518Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B31B6",
    d: "M1638.41 364.057V-98.83c-533.23-162.223-1521.857-389.336-1210.583 0C739.101 290.507 1364.58 371.986 1638.41 364.058Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v856H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 3400.18,
    height: 2364.94,
    x: -430,
    y: -543.802,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_11_4",
    stdDeviation: 115
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.03b90973e949f6d42491ef77e511254b.svg";
export { ForwardRef as ReactComponent };